import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getFileDownloadRequest: [],
  getFileDownloadSuccess: ["fileDownload"],
  getFileDownloadFailure: null,
});

export const GetFileDownloadTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
});

export const GetFileDownloadSelectors = {
  getData: (state: any) => state.getFileDownload.data,
  isFetching: (state: any) => state.getFileDownload.fetching,
  isSuccess: (state: any) => state.getFileDownload.success,
  hasError: (state: any) => state.getFileDownload.error,
};

export const request = (state: any, action: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { fileDownload } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    fileDownload,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FILE_DOWNLOAD_REQUEST]: request,
  [Types.GET_FILE_DOWNLOAD_SUCCESS]: success,
  [Types.GET_FILE_DOWNLOAD_FAILURE]: failure,
});
